import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-500 my-4"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 1,
  class: "flex items-center gap-x-5 w-full"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = ["for"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["for"]
const _hoisted_11 = {
  key: 1,
  class: "flex items-center gap-x-5 w-full"
}
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = ["for"]
const _hoisted_14 = {
  key: 1,
  class: "mt-2 text-sm text-red-600"
}

import GgmsInput from "@/components/GgmsInput.vue"
import { withDefaults, computed, ref, watch } from "vue"

interface OptionType {
    displayName: string
    value: any
    isOther?: boolean
    otherValue?: string
}

interface Props {
    modelValue: any
    label?: string
    description?: string
    required?: boolean
    inline?: boolean
    disabled?: boolean
    options: OptionType[]
    name?: string
    invalid?: boolean
    buttonsInline?: boolean
    errorMessage?: string
    inColumns?: boolean // New prop to determine if options should be displayed in columns
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsRadioSelect',
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    description: {},
    required: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    options: { default: [] as OptionType[] },
    name: { default: "" },
    invalid: { type: Boolean, default: false },
    buttonsInline: { type: Boolean, default: false },
    errorMessage: {},
    inColumns: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "update:options"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const model = computed({
    get() {
        return props.modelValue
    },
    set(value: string) {
        emit("update:modelValue", value)
    },
})

const disabledStyle = computed(() => (props.disabled ? "cursor-not-allowed opacity-70" : ""))
const starStyle = computed(() => [localInvalid.value ? "text-red-600" : "text-gray-700", "pl-1"])
const localInvalid = ref(props.invalid)
const localErrorMessage = ref(props.errorMessage)
const getRequiredStyleInline = computed(() => (props.inline ? "gap-2" : ""))
const otherValue = ref(props.options.at(-1)?.otherValue || "")
const buttonStyle = computed(() => [props.buttonsInline ? "gap-x-4" : "flex-col gap-y-4", "flex"])

watch(
    () => props.invalid,
    () => (localInvalid.value = props.invalid)
)

watch(
    () => props.errorMessage,
    () => {
        localErrorMessage.value = props.errorMessage
        localInvalid.value = props.invalid
    }
)

function disableValidationError() {
    localErrorMessage.value = ""
    localInvalid.value = false
}

function getWrapperStyleInline() {
    return props.inline ? "flex items-center gap-4" : ""
}

function getLabelStyleInline() {
    return props.inline ? "w-2/5 whitespace-nowrap pr-2 lg:pr-0" : "mb-4"
}

function setOptionLengthStyle(isOther: boolean | undefined) {
    return isOther ? "w-full" : "w-fit"
}

function onItemSelect(value: any) {
    if (props.disabled) return
    disableValidationError()
    model.value = value
    emit("update:options", otherValue.value)
}

// Function to calculate the number of columns for grid display
function getColumnCount() {
    if (!props.inColumns) return 1
    return Math.ceil(Math.sqrt(props.options.length)) // Square root approximation for equal columns
}

// Prevents the radio button from being selected when clicking on the input field
function notSelectOnInputClick() {
    return
}

return (_ctx: any,_cache: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(getWrapperStyleInline())
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex", getRequiredStyleInline.value])
      }, [
        _createElementVNode("label", {
          for: _ctx.name,
          class: _normalizeClass([getLabelStyleInline(), 'block text-sm font-medium text-gray-700 '])
        }, _toDisplayString(_ctx.label), 11, _hoisted_1),
        (_ctx.required)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(starStyle.value)
            }, "*", 2))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.description), 1))
        : _createCommentVNode("", true),
      _createElementVNode("fieldset", {
        class: _normalizeClass(buttonStyle.value)
      }, [
        (_ctx.inColumns)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "grid gap-y-4 gap-x-6",
              style: _normalizeStyle({ 'grid-template-columns': `repeat(${getColumnCount()}, 1fr)` })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option.value,
                  class: _normalizeClass(["flex items-center cursor-pointer", [disabledStyle.value, setOptionLengthStyle(option?.isOther)]]),
                  onClick: _withModifiers(($event: any) => (onItemSelect(option.value)), ["prevent","stop"])
                }, [
                  (!option?.isOther)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_RadioButton, {
                          modelValue: model.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
                          id: _ctx.name + '-' + index,
                          name: _ctx.name,
                          value: option.value,
                          disabled: _ctx.disabled
                        }, null, 8, ["modelValue", "id", "name", "value", "disabled"]),
                        _createElementVNode("p", {
                          for: _ctx.name,
                          class: _normalizeClass(["text-sm font-medium text-gray-700 ml-2 cursor-pointer", disabledStyle.value])
                        }, _toDisplayString(option.displayName), 11, _hoisted_4)
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_RadioButton, {
                            modelValue: model.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
                            id: _ctx.name + '-' + index,
                            name: _ctx.name,
                            value: option.value,
                            disabled: _ctx.disabled
                          }, null, 8, ["modelValue", "id", "name", "value", "disabled"]),
                          _createElementVNode("p", {
                            for: _ctx.name,
                            class: _normalizeClass(["text-sm font-medium text-gray-700 ml-2 cursor-pointer", disabledStyle.value])
                          }, " Other: ", 10, _hoisted_7)
                        ]),
                        _createVNode(GgmsInput, {
                          modelValue: otherValue.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((otherValue).value = $event)),
                          small: true,
                          disabled: _ctx.disabled,
                          class: "w-full",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (notSelectOnInputClick()), ["prevent","stop"])),
                          onInput: _cache[4] || (_cache[4] = ($event: any) => (onItemSelect('Other')))
                        }, null, 8, ["modelValue", "disabled"])
                      ]))
                ], 10, _hoisted_3))
              }), 128))
            ], 4))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option.value,
                  class: _normalizeClass(["flex items-center cursor-pointer mb-4", [disabledStyle.value, setOptionLengthStyle(option?.isOther)]]),
                  onClick: _withModifiers(($event: any) => (onItemSelect(option.value)), ["prevent","stop"])
                }, [
                  (!option?.isOther)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_RadioButton, {
                          modelValue: model.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((model).value = $event)),
                          id: _ctx.name + '-' + index,
                          name: _ctx.name,
                          value: option.value,
                          disabled: _ctx.disabled
                        }, null, 8, ["modelValue", "id", "name", "value", "disabled"]),
                        _createElementVNode("p", {
                          for: _ctx.name,
                          class: _normalizeClass(["text-sm font-medium text-gray-700 ml-2 cursor-pointer", disabledStyle.value])
                        }, _toDisplayString(option.displayName), 11, _hoisted_10)
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_RadioButton, {
                            modelValue: model.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((model).value = $event)),
                            id: _ctx.name + '-' + index,
                            name: _ctx.name,
                            value: option.value,
                            disabled: _ctx.disabled
                          }, null, 8, ["modelValue", "id", "name", "value", "disabled"]),
                          _createElementVNode("p", {
                            for: _ctx.name,
                            class: _normalizeClass(["text-sm font-medium text-gray-700 ml-2 cursor-pointer", disabledStyle.value])
                          }, " Other: ", 10, _hoisted_13)
                        ]),
                        _createVNode(GgmsInput, {
                          modelValue: otherValue.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((otherValue).value = $event)),
                          small: true,
                          disabled: _ctx.disabled,
                          class: "w-full",
                          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (notSelectOnInputClick()), ["prevent","stop"])),
                          onInput: _cache[9] || (_cache[9] = ($event: any) => (onItemSelect('Other')))
                        }, null, 8, ["modelValue", "disabled"])
                      ]))
                ], 10, _hoisted_9))
              }), 128))
            ]))
      ], 2),
      (localErrorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(localErrorMessage.value), 1))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})